<div class="uil-card-span-12 uil-card-template asset-card">
  <!-- *ngFor="let card of assetList" -->
  <!-- header for restricted type -->

  <div class="row card-header">
    <!-- <div class="col-md-12 col-lg-12"> -->
    <div class="col-md-12">
      <span
        class="chip-title internal-chip-title"
        innerHTML="{{ card.Capability_Name | highlightPipe: searchText }}"
      ></span>
    </div>
    <!-- </div> -->
  </div>

  <!--  Industry name , subindustry name and asset title -->
  <div (click)="viewAssetDetails(card)" style="cursor: pointer">
    <div class="uil-card-title-multi-item-wrapper asset-multiple-details">
      <div class="uil-card-title-area">
        <div class="uil-card-strapline strapline">
          <span
            title="{{ card.industries_name }}"
            innerHTML="{{ card.industries_name | highlightPipe: searchText }}"
          ></span>
        </div>

        <!-- <a href="{{ card.Asset_Link }}" target="_blank"> -->
        <div
          class="uil-card-title card-title"
          [title]="card.Asset_Name"
          *ngIf="card.Asset_Name"
          innerHTML="{{ card.Asset_Name | highlightPipe: searchText }}"
        ></div>
        <!-- </a> -->
      </div>
    </div>

    <!-- Asset type -->
    <div class="asset-type-row">
      <span class="asset-type-text" style="font-weight: 500">Asset Type: </span>
      <span
        class="asset-type-text asset-type-value"
        [title]="card.Asset_Type_Name"
        *ngIf="card.Asset_Type_Name"
        innerHTML="{{ card.Asset_Type_Name | highlightPipe: searchText }}"
      ></span>
    </div>

    <!-- Asset description -->
    <div
      class="card-body-area"
      innerHTML="{{ card.Asset_Description | highlightPipe: searchText }}"
    ></div>
  </div>

  <!-- Asset update date -->
  <div class="date-container" *ngIf="card.Updated_On">
    <span style="font-weight: 500">Modified : </span
    ><span
      style="font-weight: 400"
      innerHTML="{{
        card.Updated_On | date: 'dd-MMM-yyyy' | highlightPipe: searchText
      }}"
    ></span>
  </div>

  <div class="row uil-card-footer asset-card-footer">
    <!-- Asset Link and view count-->
    <div class="col-md-3 view-text">
      <span>View</span>
      <span class="asset-view-count" title="View count">{{
        card.View_Count
      }}</span>
      <!-- <span class="">2.3k</span> -->
    </div>

    <div class="col-md-9 footer-icon-container">
      <span
        class="user-rating-count"
        title="Rate count"
        *ngIf="card.User_Rating_Count"
        >{{ card.User_Rating_Count }}</span
      >
      <!-- <div class="star-rating-section">
        <input type="radio" [id]="'star5'+card.Asset_Id" [name]="'rate'+card.Asset_Id" value="5" [checked]="card.Asset_rating==5" />
        <label [for]="'star5'+card.Asset_Id" title="text" (click)="onRating(card,5)">5 stars</label>
        <input type="radio" [id]="'star4'+card.Asset_Id" [name]="'rate'+card.Asset_Id" value="4" [checked]="card.Asset_rating==4"/>
        <label [for]="'star4'+card.Asset_Id" title="text" (click)="onRating(card,4)">4 stars</label>
        <input type="radio" [id]="'star3'+card.Asset_Id" [name]="'rate'+card.Asset_Id" value="3" [checked]="card.Asset_rating==3"/>
        <label [for]="'star3'+card.Asset_Id" title="text" (click)="onRating(card,3)">3 stars</label>
        <input type="radio" [id]="'star2'+card.Asset_Id" [name]="'rate'+card.Asset_Id" value="2" [checked]="card.Asset_rating==2"/>
        <label [for]="'star2'+card.Asset_Id" title="text" (click)="onRating(card,2)">2 stars</label>
        <input type="radio" [id]="'star1'+card.Asset_Id" [name]="'rate'+card.Asset_Id" value="1" [checked]="card.Asset_rating==1"/>
        <label [for]="'star1' + card.Asset_Id" title="text" (click)="onRating(card,1)">1 star</label>
      </div> -->
      <div
        class="star-rating-section"
        [title]="'Average Rating: ' + card.Average_Rating"
      >
        <span
          class="fa star-icon"
          *ngFor="let item of rating"
          [ngClass]="{
            'fa-star': item.isRated,
            'star-icon-rated': item.isRated,
            'fa-star-o': !item.isRated,
            'star-icon': !item.isRated
          }"
        ></span>
      </div>
      <!-- Asset like, share, bookmark icons -->
      <span
        class="uil-color-secondary bookmark-icon fa"
        [title]="
          card.User_BookMarked_Assets
            ? 'Remove from My Bookmarks'
            : 'Add to My Bookmarks'
        "
        [ngClass]="{
          'fa-bookmark-o': !card.User_BookMarked_Assets,
          'fa-bookmark': card.User_BookMarked_Assets,
          'is-bookmarked': card.User_BookMarked_Assets
        }"
        (click)="onBookmarkClick(card)"
      >
      </span>
    </div>
  </div>
</div>

<div class="spaceBox"></div>
